import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=64c9fb6b&scoped=true&"
import script from "../../models/authority/new-edit.ts?vue&type=script&lang=ts&"
export * from "../../models/authority/new-edit.ts?vue&type=script&lang=ts&"
import style0 from "./NewEdit.vue?vue&type=style&index=0&id=64c9fb6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c9fb6b",
  null
  
)

export default component.exports